<template>
  <div class="c-imgModal">
    <div class="c-imgModal__inner">
      <div class="c-imgModal__head">
        <span class="c-imgModal__count">{{isDetailIndex + 1}}/{{propPhotos.length}}</span>
        <h1 class="c-imgModal__title">写真一覧</h1>
        <img class="c-imgModal__close" src="@/assets/icon-close-button-original.png" alt="" @click="toBack">
      </div>

      <ul class="c-imgModal__list" v-show="!isDetail">
        <li class="c-imgModal__item" v-for="(item, index) in propPhotos" :key="index">
          <a class="c-imgModal__link" @click="toggleDetail(index)">
            <img class="c-imgModal__img" :src="item.img" :alt="item.text">
          </a>
        </li>
      </ul>

      <!-- 詳細イメージ -->
      <div class="c-imgModal__detail" v-show="isDetail">
        <h2 class="c-imgModal__detailTitle">{{propName}}</h2>
        <div class="c-imgModal__detailImgArea">
          <span class="c-imgModal__detailImgArea__prev" @click="prev"></span>
          <span class="c-imgModal__detailImgArea__next" @click="next"></span>
          <img :src="propPhotos[isDetailIndex].img" :alt="propPhotos[isDetailIndex].text">
        </div>
        <span class="c-imgModal__detailText">{{propPhotos[isDetailIndex].text}}</span>

        <common-button
          :callback="toggleDetail"
          :attr="[]"
          :title="'写真一覧'"
          :middle="true"
          :no_width="true"
          :font_bold="true"
          :icon="'thumbnails-grey'" />
      </div>
    </div>
  </div>
</template>

<script>
import CommonButton from '@/components/parts/button/CommonButton';

export default {
  name: 'CommonImgModal',
  props: ['propPhotos', 'isModalList', 'propName', 'detailIndex'],
  components: {
    CommonButton,
  },
  data() {
    return {
      isDetail: false,
      isDetailIndex: 0,
    };
  },
  mounted() {
  },
  created() {
    if (this.detailIndex !== null) {
      this.isDetailIndex = this.detailIndex;
      this.isDetail = true;
    }
  },
  computed: {
    isPageChild: {
      get() {
        return this.isModalList;
      },
      set(isModalList) {
        this.$emit('input', isModalList);
      },
    },

  },
  methods: {
    toBack() {
      this.isPageChild = false;
      document.body.style.position = 'unset';
      document.body.style.top = 'unset';
      document.body.style.bottom = 'unset';
      document.body.style.right = 'unset';
      document.body.style.left = 'unset';
    },
    toggleDetail(index = 0) {
      this.isDetailIndex = index;
      this.isDetail = !this.isDetail;
    },
    prev() {
      this.isDetailIndex = this.isDetailIndex !== 0 ? this.isDetailIndex - 1 : this.propPhotos.length - 1;
    },
    next() {
      this.isDetailIndex = this.isDetailIndex !== this.propPhotos.length - 1 ? this.isDetailIndex + 1 : 0;
    },

  },
};
</script>

<style lang='scss' scoped>
@charset 'UTF-8';

.c-imgModal {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100vh;
  padding-bottom: 100px;
  z-index: 1000;
  overflow-y: auto;

  &__inner {
    max-width: 740px;
    margin: 0 auto;
  }
  &__head {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #fff;
    padding: 20px 6px 24px;
  }
  &__count {
    font-size: 14px;
    color: #666;
    line-height: 1.2;
  }
  &__title {
    font-size: 18px;
    font-weight: bold;
    line-height: 1.2;
    color: #666;
  }
  &__close {
    width: 36px;
    height: 36px;
    cursor: pointer;
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 76px;
  }
  &__item {
    width: calc((100% / 3) - 7px);
    margin-right: 10px;
    margin-bottom: 10px;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  &__img {
    width: 100%;
    height: 180px;
    object-fit: contain;
  }

  // detail
  &__detail {
    padding-top: 76px;
  }
  &__detailTitle {
    padding: 14px 0;
    font-size: 18px;
    font-weight: bold;
    color: #666;
    line-height: 1.3;
    text-align: center;
  }
  &__detailImgArea {
    position: relative;

    &__prev, &__next {
      position: absolute;
      top: 50%;
      display: inline-block;
      content: "";
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: rgba(255,255,255,0.8);
      background-image: url(@/assets/icon-arrow-originl.png);
      background-position: center;
      background-size: 18px;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    &__prev {
      left: 20px;
      transform: translateY(-50%) rotate(180deg);
    }
    &__next {
      right: 20px;
      transform: translateY(-50%);
    }

    img {
      width: 100%;
      height: 466px;
      object-fit: contain;
    }
  }
  &__detailText {
    display: block;
    margin-top: 10px;
    margin-bottom: 50px;
    font-size: 14px;
    line-height: 1.5em;
    color: #666;
  }
}

@media screen and (max-width: 999px) {
  .c-imgModal {
    &__head {
      padding: 20px;
    }
    &__detail {
      padding: 76px 64px 0;
    }
    &__detailImgArea {
      img {
        width: 100%;
        height: 63vw;
      }
    }
    &__detailTitle {
      font-size: 16px;
    }
  }
}

@media screen and (max-width: 768px) {
  .c-imgModal {
    &__item {
      width: calc((100% / 3) - 3px);
      margin-right: 4px;
      margin-bottom: 4px;
    }
    &__img {
      height: calc( ( 100vw - 8px ) / 4 )
    }
    &__detail {
      padding: 76px 0 0;
    }
    &__detailTitle {
      font-size: 14px;
    }
    &__detailText {
      padding: 0 20px;
    }
  }
}
</style>
